export const treeSample = [
  {
    key: '0',
    label: 'РТК',
    icon: 'pi pi-fw pi-inbox',
    children: [
      {
        key: '0-0',
        label: 'НФТС ЮГ',
        icon: 'pi pi-fw pi-cog',
        children: [
          {
            key: '0-0-0',
            label: 'Фил Ставропольск',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-0-0-0',
                label: 'Вышегородцева Елена Федоровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-0-1',
                label: 'Симоненко Е.И.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-0-2',
                label: 'Хатинова Наталья Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-0-3',
                label: 'Троценко Олег Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-0-4',
                label: 'Кравченко Марина Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-0-5',
                label: 'Рамазанов Игорь Ильясович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-0-6',
                label: 'Неботова Светлана Юрьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-0-7',
                label: 'Ващенко Евгений Семенович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-0-1',
            label: 'Фил Сев-Осетинск',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-0-1-0',
                label: 'Тетдоева Л.В.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-1-1',
                label: 'Газдаров Тамерлан Агубеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-1-2',
                label: 'Василенко Александр Алексеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-0-2',
            label: 'Фил Ростовский',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-0-2-0',
                label: 'Резванова С.В.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-2-1',
                label: 'Пуляева Ирина Ивановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-2-2',
                label: 'Писаренко Александр Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-2-3',
                label: 'Камачкина Елена Петровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-2-4',
                label: 'Палюх Светлана Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-2-5',
                label: 'Фатеева Ирина Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-2-6',
                label: 'Ефремова Ирина Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-2-7',
                label: 'Игнатенко марина ивановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-2-8',
                label: 'Ермолаева Элла викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-2-9',
                label: 'Коваль Лариса Андреевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-0-3',
            label: 'Фил Краснодарск',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-0-3-0',
                label: 'Францева Л.Н.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-3-1',
                label: 'Порубова Елена Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-3-2',
                label: 'Эрнст Елизавета Константиновна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-3-3',
                label: 'Женская Екатерина Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-3-4',
                label: 'Козырев Владимир Григорьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-3-5',
                label: 'Шевелев Анатолий Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-3-6',
                label: 'Капарулин Олег Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-3-7',
                label: 'Шпильберг Михаил Михайлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-3-8',
                label: 'Гришанова Елена Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-3-9',
                label: 'Ковалев Андрей Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-3-10',
                label: 'Ковешников Кирилл Олегович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-3-11',
                label: 'Серебренников Владимир Андреевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-0-4',
            label: 'Фил Калмыцкий',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-0-4-0',
                label: 'Манжикова Г.В.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-4-1',
                label: 'Мучаева Валентина Бадмаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-4-2',
                label: 'Лободин Александр Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-4-3',
                label: 'Манжиков Александр Наранович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-4-4',
                label: 'Комаров Андрей Петрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-4-5',
                label: 'Очир-Гаряев Антон Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-0-5',
            label: 'Фил Каб-Балкарск',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-0-5-0',
                label: 'Андросов Вячеслав Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-5-1',
                label: 'Хакягова Елена Васильевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-0-6',
            label: 'Фил Ингушский',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-0-6-0',
                label: 'Льянов Ильяс Абдул-Хамидович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-0-7',
            label: 'Фил Дагестанский',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-0-7-0',
                label: 'Алисултанова А.Г.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-7-1',
                label: 'Хайбулаева Татьяна Ивановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-7-2',
                label: 'Ройтман Олег Витальевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-7-3',
                label: 'Ахмедова Альбина Хасбулатовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-7-4',
                label: 'Муртузалиева Жанна Максудовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-7-5',
                label: 'Гришин Сергей Юрьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-0-8',
            label: 'Фил Волгоградск',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-0-8-0',
                label: 'Дорохова М.В.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-8-1',
                label: 'Попова Елена Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-8-2',
                label: 'Гаренко Лилия Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-0-9',
            label: 'Фил Астраханский',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-0-9-0',
                label: 'Сунникова Ольга Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-9-1',
                label: 'Акишина И.Б.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-9-2',
                label: 'Изюмников Иван Анатольевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-9-3',
                label: 'Анисимова Татьяна Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-9-4',
                label: 'Левченко Александр Валерьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-9-5',
                label: 'Ризаев Рафаэль Мирзага',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-9-6',
                label: 'Штонда Татьяна Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-0-10',
            label: 'ОУСС',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-0-10-0',
                label: 'Якимчук Павел Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-10-1',
                label: 'Марценко Александр Васильевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-10-2',
                label: 'Малинин Николай Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-10-3',
                label: 'Михальчук Станислав Валерьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-10-4',
                label: 'Меркурьев Дмитрий Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-0-11',
            label: 'ОМСС',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-0-11-0',
                label: 'Капорина Елена Алексеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-11-1',
                label: 'Танянская Валентина Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-11-2',
                label: 'Зозуля Ольга Борисовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-0-12',
            label: 'НТМСиРС Юг',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-0-12-0',
                label: 'Подгорная Юлия Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-12-1',
                label: 'Семенихин Сергей Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-0-13',
            label: 'Инвентарная СУРТС',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-0-13-0',
                label: 'Семенова Екатерина Савватьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-1',
                label: 'Попова Елена Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-2',
                label: 'Селютин Александр Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-3',
                label: 'Коваленко Игорь Геннадьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-4',
                label: 'Самарский Сергей Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-5',
                label: 'Кононенко Герман Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-6',
                label: 'Пономаренко Наталья Юрьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-7',
                label: 'Пелипенко Алексей Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-8',
                label: 'Приймак Сергей Иванович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-9',
                label: 'Старовойтов Сергей Иванович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-10',
                label: 'Федоров Дмитрий Михайлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-11',
                label: 'Коврыгин Сергей Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-12',
                label: 'Трипольский Михаил Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-13',
                label: 'Митрохин Сергей Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-14',
                label: 'Асваров Фарид Насирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-15',
                label: 'Абасов Теймур Афизович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-16',
                label: 'Мороз Валентин Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-17',
                label: 'Серебрякова Дина Далаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-18',
                label: 'Филимонов Александ Юрьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-19',
                label: 'Диков Леонид Алексеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-20',
                label: 'Селютина Аксана Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-21',
                label: 'Нелюбов Владимир Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-22',
                label: 'Пивоварова Евгения Витальевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-23',
                label: 'Вербицкий Владимир Георгиевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-24',
                label: 'Колмогорова Лариса Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-25',
                label: 'Бумагина Ольга Ивановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-26',
                label: 'Торчинов Сергей Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-27',
                label: 'Тараненко Константин Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-28',
                label: 'Жуков Сергей  Леонидович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-29',
                label: 'Круглов Николай Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-30',
                label: 'Тупикова Елена Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-31',
                label: 'Демакина Юлия Олеговна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-32',
                label: 'Шелестов Владимир Михайлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-33',
                label: 'Папко Юлия Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-34',
                label: 'Катенев Игорь Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-35',
                label: 'Янкус Василий Евгеньевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-36',
                label: 'Манжула Сергей Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-37',
                label: 'Чегодаева Наталья Павловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-38',
                label: 'Кобяков Андрей Евгеньевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-39',
                label: 'Федоров Петр Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-40',
                label: 'Мужилко Руслан Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-41',
                label: 'Сидоренко Кирилл Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-42',
                label: 'Ломакин Никита Дмитриевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-43',
                label: 'Марчук Владимир Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-13-44',
                label: 'Деревягина Елена Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-0-14',
            label: 'ДРОС Юг',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-0-14-0',
                label: 'Чернуха Марина Геннадьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-0-14-1',
                label: 'Кузнецова Татьяна Валерьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-0-15',
            label: 'ГУТС (МРФ ЮГ)',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-0-15-0',
                label: 'Колмогоров Виталий Анатольевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          }
        ],
        data: 'Подразделение'
      },
      {
        key: '0-1',
        label: 'НФТС Центр',
        icon: 'pi pi-fw pi-cog',
        children: [
          {
            key: '0-1-0',
            label: 'Фил Ярос и Костр',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-1-0-0',
                label: 'Авдеев Михаил Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-0-1',
                label: 'Михайлов Денис Витальевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-0-2',
                label: 'Юриков Александр Валерьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-0-3',
                label: 'Коузов Сергей Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-0-4',
                label: 'Радзивил Вячеслав Цезариевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-1-1',
            label: 'Фил Тверской',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-1-1-0',
                label: 'Рыжова Ирина Станиславовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-1-1',
                label: 'Захарова Марина Евгеньевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-1-2',
                label: 'Вепрева Галина Евгеньевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-1-3',
                label: 'Евсюкова Юлия Владиславовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-1-4',
                label: 'Стажок Елена Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-1-5',
                label: 'Мельник Константин Павлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-1-6',
                label: 'Тихомирова Наталья Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-1-7',
                label: 'Комарова Светлана Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-1-8',
                label: 'Прохаев Сергей Валентинорвич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-1-9',
                label: 'Прохаева Лариса Витальевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-1-10',
                label: 'Некрасова Татьяна Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-1-11',
                label: 'Кутейникова Татьяна Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-1-12',
                label: 'Лощагина Елена Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-1-2',
            label: 'Фил Тамбовск',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-1-2-0',
                label: 'Суханова Л.Н.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-2-1',
                label: 'Попов Александр Михайлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-2-2',
                label: 'Солдатов Евгений Русланович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-1-3',
            label: 'Фил Смоленский',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-1-3-0',
                label: 'Шилова Людмила Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-3-1',
                label: 'Вирюкина Наталья Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-3-2',
                label: 'Лукашук Вероника Олеговна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-3-3',
                label: 'Снегуров Сергей Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-3-4',
                label: 'Чиновникова Елена Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-3-5',
                label: 'Краснова Александра Леонидовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-3-6',
                label: 'Демьянов Данила Алексеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-3-7',
                label: 'Гусева Марина Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-3-8',
                label: 'Дмитриева Ольга Витальевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-3-9',
                label: 'Корман Ольга Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-3-10',
                label: 'Малышев Виталий Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-3-11',
                label: 'Кузьмина Елена Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-3-12',
                label: 'Винокурова Галина Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-1-4',
            label: 'Фил Липецкий',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-1-4-0',
                label: 'Назарова В.А.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-4-1',
                label: 'Белоусова Цветана Евгеньевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-4-2',
                label: 'Первеева Юлия Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-4-3',
                label: 'Волокитина Татьяна Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-4-4',
                label: 'Евсюкова Юлия Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-4-5',
                label: 'Лексин Андрей Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-4-6',
                label: 'Черкасов Владимир Вячеславович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-4-7',
                label: 'Базюк Геннадий Иванович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-4-8',
                label: 'Жданов Юрий Андреевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-4-9',
                label: 'Попова Лада Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-1-5',
            label: 'Фил Курский',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-1-5-0',
                label: 'Сопова Валентина Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-5-1',
                label: 'Зиновьев Вадим Витальевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-5-2',
                label: 'Лебедев Андрей Анатольевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-5-3',
                label: 'Кузина Наталья Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-5-4',
                label: 'Абрамов Денис Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-5-5',
                label: 'Ларина Алла Алексеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-1-6',
            label: 'Фил Калужский',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-1-6-0',
                label: 'Пользователь Фил Калужский',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-6-1',
                label: 'Царева Екатерина Федоровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-6-2',
                label: 'Комиссаров Александр Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-6-3',
                label: 'Бухарова Татьяна Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-6-4',
                label: 'Гурьева Екатерина Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-1-7',
            label: 'Фил Воронежский',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-1-7-0',
                label: 'Приймак Татьяна Юрьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-7-1',
                label: 'Высоцкая Ольга Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-7-2',
                label: 'Дедов Андрей Алексеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-7-3',
                label: 'Филюшкин Владимир Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-7-4',
                label: 'Крымова Марина Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-7-5',
                label: 'Дадон Сергей Васильевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-7-6',
                label: 'Вербович Вячеслав Валерьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-1-8',
            label: 'Фил Влад и Иван',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-1-8-0',
                label: 'Коблов Андрей Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-8-1',
                label: 'Колтеленкова Марина Яковлевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-8-2',
                label: 'Созонтов Дмитрий Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-8-3',
                label: 'Иванов Александр Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-8-4',
                label: 'Гут Галина Васильевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-8-5',
                label: 'Карпов Валерий Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-8-6',
                label: 'Горшков Сергей Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-8-7',
                label: 'Шерстобитов Вадим Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-1-9',
            label: 'Фил Брянск и Орл',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-1-9-0',
                label: 'Степичева Татьяна Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-9-1',
                label: 'Купцова Ирина Петровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-9-2',
                label: 'Лутова Екатерина Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-1-10',
            label: 'Фил Белгородский',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-1-10-0',
                label: 'Куденко Л. Н.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-10-1',
                label: 'Орлова Ольга Павловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-10-2',
                label: 'Агафонов Александр Алексеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-10-3',
                label: 'Канищев Александр Павлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-10-4',
                label: 'Туцкая Вероника Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-10-5',
                label: 'Ковалева Евгения Васильевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-10-6',
                label: 'Беликов Никита Олегович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-10-7',
                label: 'Лукьянчинков Иван Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-10-8',
                label: 'Горбунов Николай Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-1-11',
            label: 'ТЦТЭТ Западный',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-1-11-0',
                label: 'Сомова Татьяна Петровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-11-1',
                label: 'Старший диспетчер УПУ',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-11-2',
                label: 'Оленикова Галина Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-11-3',
                label: 'Астафьева Анна Васильевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-11-4',
                label: 'Гоева Екатерина Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-11-5',
                label: 'Машкарин Виталий Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-11-6',
                label: 'Авраменко Вячеслав Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-11-7',
                label: 'Передрий Наталья Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-11-8',
                label: 'Рыбникова Елена Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-11-9',
                label: 'Мочалов Александр Анатольевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-11-10',
                label: 'Булатов Андрей Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-11-11',
                label: 'Соловьева Татьяна Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-11-12',
                label: 'Голова Елена Ивановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-11-13',
                label: 'Огородник Марина Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-11-14',
                label: 'Кочетков Николай Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-11-15',
                label: 'Купреенкова Светлана Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-11-16',
                label: 'Сухарева Людмила Ивановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-11-17',
                label: 'Байбурина Лена Венеровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-1-12',
            label: 'ТЦТЭТ Восточный',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-1-12-0',
                label: 'Гробищева Надежда Семеновна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-12-1',
                label: 'УПУ Смена диспетчер',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-12-2',
                label: 'Мельникова Татьяна Геннадьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-12-3',
                label: 'Агафонова Н.Д.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-12-4',
                label: 'Бородкина Татьяна Аркадьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-12-5',
                label: 'Ситко Ольга Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-12-6',
                label: 'Хавронина Анна Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-12-7',
                label: 'Григорьев Антон Олегович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-12-8',
                label: 'Бнатова Светлана Егоровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-12-9',
                label: 'Харитонов Александр Федорович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-1-13',
            label: 'НТМиРС Центр',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-1-13-0',
                label: 'Житецкая Екатерина Раисовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-13-1',
                label: 'Челянова Юлия Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-13-2',
                label: 'Репин Андрей Евгеньевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-1-14',
            label: 'МОУТЭ',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-1-14-0',
                label: 'Жирякова Лариса Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-14-1',
                label: 'Юдина Елена Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-14-2',
                label: 'Мосина Оксана Игоревна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-14-3',
                label: 'Козырева Ирина Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-14-4',
                label: 'Бокова Валентина Львовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-14-5',
                label: 'Кружкова Елена Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-1-15',
            label: 'МГУТЭ',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-1-15-0',
                label: 'Шуринова Любовь Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-1',
                label: 'Селина Елена Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-2',
                label: 'Акимова Нина Дмитриевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-3',
                label: 'Липатова Светлана Геннадиевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-4',
                label: 'Литвин М.И.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-5',
                label: 'Косарикова Ирина Валентиновна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-6',
                label: 'Чертовских Ирина Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-7',
                label: 'Левина Елена Валентиновна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-8',
                label: 'Бирон Любовь Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-9',
                label: 'Самохина Ольга Серафимовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-10',
                label: 'Блудова Марина Мяликовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-11',
                label: 'Иванов Геннадий Евгеньевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-12',
                label: 'Эсаулова Ирина Семеновна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-13',
                label: 'Галеева Светлана Семеновна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-14',
                label: 'Емельянов Владимир Петрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-15',
                label: 'Ильенкова Ольга Юрьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-16',
                label: 'Заитов Роман Алимович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-17',
                label: 'Блохина Ирина Юрьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-18',
                label: 'Александрова Надежда Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-19',
                label: 'Сорокина Вера Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-20',
                label: 'Буравцова Мария Петровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-21',
                label: 'Васильев Александр Васильевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-22',
                label: 'Чеклина Екатерина Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-23',
                label: 'Межрауп Михаил Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-24',
                label: 'Жаббаров Ильдар Шамилевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-25',
                label: 'Свинцов Александр Алексеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-26',
                label: 'Коробов Дмитрий Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-27',
                label: 'Еропкина Лариса Станиславовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-28',
                label: 'Демидова Валерия Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-29',
                label: 'Сергеева Анастасия Станиславовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-30',
                label: 'Дербенева Ирена Евгеньевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-31',
                label: 'Синютина Елена Фроловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-32',
                label: 'Казакова Антонина Петровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-33',
                label: 'Киреева Алевтина Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-34',
                label: 'Морозов Павел Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-35',
                label: 'Бадера Олег Алексеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-36',
                label: 'Исаева Юлия Васильевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-37',
                label: 'Тулинова Марина Юрьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-38',
                label: 'Иванова Розалия Маратовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-39',
                label: 'Назарова Янина Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-40',
                label: 'Полухин Виталий Григорьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-41',
                label: 'Казарова Любовь Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-42',
                label: 'Савичев Роман Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-43',
                label: 'Садовская Ольга Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-44',
                label: 'Аверьянова Юлия Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-45',
                label: 'Цапулина Ольга Олеговна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-46',
                label: 'Пушкина Ирина Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-47',
                label: 'Игнатова Наталия Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-48',
                label: 'Маловечко Юлия Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-15-49',
                label: 'Орлова Маргарита Витальевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-1-16',
            label: 'Инвентарная СУРТС',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-1-16-0',
                label: 'Нестеренко Ольга Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-1',
                label: 'Алимова Светлана Васильевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-2',
                label: 'Чеботарев Александр Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-3',
                label: 'Пустынина Елена Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-4',
                label: 'Федоренко Юлия Евгеньевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-5',
                label: 'Вахланова Галина Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-6',
                label: 'Белевский А.В.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-7',
                label: 'Устинова Ирина Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-8',
                label: 'Копылова Надежда Григорьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-9',
                label: 'Ложкина Юлия Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-10',
                label: 'Рукавец Анна Вячеславовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-11',
                label: 'Шамаева И.Ж.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-12',
                label: 'Кошелев Юрий Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-13',
                label: 'Швецова Ксения Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-14',
                label: 'Прыткова Оксана Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-15',
                label: 'Кошелев Юрий Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-16',
                label: 'Исайкина Любовь Валерьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-17',
                label: 'Стародубцева Светлана Валентиновна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-18',
                label: 'Белогур Ольга Юрьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-19',
                label: 'Поликаркина Надежда Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-20',
                label: 'Мосина Оксана Игорьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-21',
                label: 'Шубцова Людмила Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-22',
                label: 'Комаров Сергей Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-23',
                label: 'Фетисова Надежда Григорьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-24',
                label: 'Иванов Константин Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-25',
                label: 'Морчев Павел Павлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-26',
                label: 'Гинак Евгений Михайлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-27',
                label: 'Зырянова Людмила Васильевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-28',
                label: 'Целиков Александр Андреевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-29',
                label: 'Осадчий Игорь Станиславович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-30',
                label: 'Сергеев Александр Анатольевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-31',
                label: 'Иванова Елена Геннадиевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-32',
                label: 'Кузнецов Андрей Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-33',
                label: 'Колесникова Анна Борисовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-34',
                label: 'Смена ЛТУ-004',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-35',
                label: 'Башигин Павел Евгеньевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-36',
                label: 'Мороз Марина Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-37',
                label: 'Илюхина Елена Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-38',
                label: 'Яськов Сергей Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-39',
                label: 'Кочергина Ольга Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-40',
                label: 'Старший диспетчер УПУ',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-41',
                label: 'Хохлов Андрей Аркадьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-42',
                label: 'Клюев Геннадий Анатольевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-43',
                label: 'Кожин Александр Георгиевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-44',
                label: 'Трофимова Ольга Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-45',
                label: 'Соколухина Ольга Алексеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-46',
                label: 'Леонтьева Светлана Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-47',
                label: 'Паричко Михаил Брониславович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-48',
                label: 'Логинов Владислав Юрьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-49',
                label: 'Наливайко Владимир Михайлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-50',
                label: 'Кравченко Евгений',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-51',
                label: 'Грибанова Ольга Серафимовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-52',
                label: 'Филюшкин Николай Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-53',
                label: 'Лопарева Марина Семеновна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-54',
                label: 'Наливайко Галина Васильевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-55',
                label: 'Шкатулла Алексей Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-56',
                label: 'Милюкова Татьяна Григорьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-57',
                label: 'Абросимов Андрей Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-58',
                label: 'Харитонов Игорь Олегович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-59',
                label: 'Котов Игорь Анатольевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-60',
                label: 'Половинкина Виктория Валериевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-61',
                label: 'Горючкин Игорь Валерьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-62',
                label: 'Оленбургер Сергей Юрьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-63',
                label: 'Чуваев Андрей Евгеньевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-64',
                label: 'Прокопов Валерий Леонидович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-65',
                label: 'Пахомов Дмитрий Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-66',
                label: 'Боровков Александр Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-67',
                label: 'Половинкин Андрей Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-68',
                label: 'Рыжкова Маргарита Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-69',
                label: 'Диспетчер',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-70',
                label: 'Полубоярова Валентина Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-71',
                label: 'Перекраснова Вера Ивановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-72',
                label: 'Смена Транспортной Сети',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-73',
                label: 'Гойшик Сергей Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-74',
                label: 'Бурцев Виктор Петрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-75',
                label: 'Лепешкевич Василий Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-76',
                label: 'Рудской Михаил Анатольевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-77',
                label: 'Демешева Валентина Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-78',
                label: 'Комаровская Наталья Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-79',
                label: 'Большакова Ирина Вячеславовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-80',
                label: 'Полякова Ирина Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-81',
                label: 'Есенина Елена Вячеславовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-82',
                label: 'Разумова Анна Ивановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-83',
                label: 'Чистяков Алексей Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-84',
                label: 'Павликов Владимир Андреевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-85',
                label: 'Заварзина Светлана Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-86',
                label: 'Поликашина Елена Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-87',
                label: 'Лапаева Ирина Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-88',
                label: 'Румянцева Елена Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-89',
                label: 'Мячева Ольга Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-90',
                label: 'Васильченко Владимир Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-91',
                label: 'Евсеева Вера Григорьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-92',
                label: 'Приймак Татьяна Юрьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-93',
                label: 'Рощина Наталия Ивановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-94',
                label: 'Чулкова Елена Алексеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-95',
                label: 'Куденко Лариса Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-96',
                label: 'Кононов Александр Алексеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-97',
                label: 'Дубенскова Елена Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-98',
                label: 'Фроленков Антон Юрьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-99',
                label: 'Огольцов Валерий Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-100',
                label: 'Старков Егор Валерьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-101',
                label: 'Марушкин Андрей Альбертович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-102',
                label: 'Солеников Федор Григорьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-103',
                label: 'Чоб Леся Григорьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-104',
                label: 'Андреев Александр Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-105',
                label: 'Попова Татьяна Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-106',
                label: 'Головинский Александр Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-107',
                label: 'Кузьмина Лариса Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-108',
                label: 'Чернояров Виктор Юрьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-109',
                label: 'Крамаровский Роман Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-110',
                label: 'Ситкевич Елена Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-111',
                label: 'Ражев Ярослав Германович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-112',
                label: 'Пурахин Михаил Константинович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-113',
                label: 'Кузнецова Лала Арифовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-114',
                label: 'Рубцова Ирина Григорьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-115',
                label: 'Михайленко Алексей Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-116',
                label: 'Натуральнов Алексей Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-117',
                label: 'Балыков Андрей Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-118',
                label: 'Тимонов Андрей Игоревич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-119',
                label: 'Чирвоный Сергей Анатольевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-120',
                label: 'Лиев Шамиль Маратович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-121',
                label: 'Никифоров Павел Валентинович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-122',
                label: 'Стародубец Андрей Павлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-123',
                label: 'Мурашова Екатерина Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-124',
                label: 'Свербежкина Светлана Валентиновна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-125',
                label: 'Глухова Екатерина Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-126',
                label: 'Корабельская Анастасия Федоровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-127',
                label: 'Ломовцева Татьяна Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-128',
                label: 'Писаренко Анатолий Иванович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-16-129',
                label: 'Брыгин Дмитрий Михайлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-1-17',
            label: 'ДРОС',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-1-17-0',
                label: 'Кукушкина Светлана Геннадьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-17-1',
                label: 'Калинина Наталья Васильевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-1-18',
            label: ' Дирекция',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-1-18-0',
                label: 'Матрохина Елена Вячеславовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-18-1',
                label: 'Абрамов Сергей Анатольевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-18-2',
                label: 'Абрамова Наталья Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-18-3',
                label: 'Аксенов Игорь Евгеньевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-18-4',
                label: 'Вовк Алексей Степанович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-18-5',
                label: 'Володин Сергей Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-18-6',
                label: 'Горюн Леонид Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-18-7',
                label: 'Ильина Ольга Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-18-8',
                label: 'Исаев Александр Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-18-9',
                label: 'Катасонов Сергей Леонидович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-18-10',
                label: 'Кулаков Сергей Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-18-11',
                label: 'Латышев Андрей Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-18-12',
                label: 'Благов Алексей Анатольевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-1-18-13',
                label: 'Пьянкова Лариса Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          }
        ],
        data: 'Подразделение'
      },
      {
        key: '0-2',
        label: 'НФТС Урал',
        icon: 'pi pi-fw pi-cog',
        children: [
          {
            key: '0-2-0',
            label: 'Фил Ямало-Ненец',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-2-0-0',
                label: 'Быкова Марина Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-0-1',
                label: 'Бриксин Павел Леонидович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-0-2',
                label: 'Панова Людмила Ивановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-0-3',
                label: 'Белякова Юлия Олеговна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-0-4',
                label: 'Немченко Андрей Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-0-5',
                label: 'Татарников Ефим Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-0-6',
                label: 'Смирнова Любовь Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-0-7',
                label: 'Погадаев Александр Валентинович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-2-1',
            label: 'Фил Челябинский',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-2-1-0',
                label: 'Хриенко И.В.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-1-1',
                label: 'Трунин Иван Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-1-2',
                label: 'Лобанова Ольга Ивановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-1-3',
                label: 'Пряникова Ирина Юрьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-1-4',
                label: 'Золотухина Лина Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-1-5',
                label: 'Безроднова Анна Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-1-6',
                label: 'Зубкова Ирина Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-1-7',
                label: 'Куликовских Александр Иванович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-1-8',
                label: 'Рудных Евгения Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-1-9',
                label: 'Смолина Светлана Валентиновна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-1-10',
                label: 'Тарабрина Елена Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-1-11',
                label: 'Циулина Елена Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-1-12',
                label: 'Макаров Виталий Анатольевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-2-2',
            label: 'Фил Ханты-Манс',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-2-2-0',
                label: 'Латыпова Любовь Алексеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-2-1',
                label: 'Жеребятьев Алексей Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-2-2',
                label: 'Булатов Ринат Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-2-3',
                label: 'Ярославцев Андрей Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-2-4',
                label: 'Щербаков Вадим Геннадьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-2-5',
                label: 'Быстров Иван Иванович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-2-6',
                label: 'Шевчик Людмила Ивановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-2-3',
            label: 'Фил Тюм и Курган',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-2-3-0',
                label: 'Копытова Любовь Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-3-1',
                label: 'Буравцова Лариса Юрьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-3-2',
                label: 'Доманова Людмила Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-3-3',
                label: 'Урюпина Ольга Павловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-3-4',
                label: 'Гладкова Любовь Яковлевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-3-5',
                label: 'Захарова Татьяна Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-2-4',
            label: 'Фил Пермский',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-2-4-0',
                label: 'Старкова Елена Прокопьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-4-1',
                label: 'Волегова О.А.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-4-2',
                label: 'Скосырева Любовь Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-4-3',
                label: 'Бурдина Любовь Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-4-4',
                label: 'Дюкина Оксана Борисовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-4-5',
                label: 'Халимов Вадим Равильевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-4-6',
                label: 'Трусникова Ольга Борисовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-2-5',
            label: 'Фил Екатеринбург',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-2-5-0',
                label: 'Урюпина С.Ю.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-5-1',
                label: 'Неугодников Федор Геннадьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-5-2',
                label: 'Колясникова Наталия Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-5-3',
                label: 'Тимошин Сергей Леонидович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-5-4',
                label: 'Клубакова Валентина Гавриловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-5-5',
                label: 'Галиуллина Татьяна Евгеньевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-5-6',
                label: 'Сухоев Алексей Павлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-5-7',
                label: 'Закожурников Дмитрий Анатольевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-5-8',
                label: 'Василевских Светлана Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-2-6',
            label: 'НТМиРС_Тупицын',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-2-6-0',
                label: 'Тупицын Владимир Борисович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-2-7',
            label: 'НТМиРС_Суханюк',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-2-7-0',
                label: 'Суханюк Алексей Михайлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-2-8',
            label: 'НТМиРС_Суханова',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-2-8-0',
                label: 'Суханова Светлана Никалаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-2-9',
            label: 'НТМиРС_Соколова',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-2-9-0',
                label: 'Соколова Вера Алексеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-2-10',
            label: 'НТМиРС_Скударнов',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-2-10-0',
                label: 'Скударнов Владимир Ефимович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-2-11',
            label: 'НТМиРС_Синицын',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-2-11-0',
                label: 'Синицын Павел Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-2-12',
            label: 'НТМиРС_Садыков',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-2-12-0',
                label: 'Садыков Вячеслав Равильевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-2-13',
            label: 'НТМиРС_Подвашецкий ',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-2-13-0',
                label: 'Подвашецкий Антон Валерьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-2-14',
            label: 'НТМиРС_Осипова',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-2-14-0',
                label: 'Осипова Татьяна Ивановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-2-15',
            label: 'НТМиРС_Нечаев',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-2-15-0',
                label: 'Нечаев Евгений Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-2-16',
            label: 'НТМиРС_Насонов',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-2-16-0',
                label: 'Насонов Сергей Павлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-2-17',
            label: 'НТМиРС_Кудрина',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-2-17-0',
                label: 'Слободчикова Татьяна Геннадьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-2-18',
            label: 'НТМиРС_Коновалов',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-2-18-0',
                label: 'Коновалов Сергей Петрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-2-19',
            label: 'НТМиРС_Зиновьев',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-2-19-0',
                label: 'Зиновьев Станислав Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-2-20',
            label: 'НТМиРС_Зеленин',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-2-20-0',
                label: 'Зеленин Анатолий Юрьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-2-21',
            label: 'НТМиРС_Дружков',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-2-21-0',
                label: 'Дружков Евгений Михайлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-2-22',
            label: 'НТМиРС_Григорьев',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-2-22-0',
                label: 'Григорьев Виталий Михайлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-2-23',
            label: 'НТМиРС_Беляев',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-2-23-0',
                label: 'Беляев Анатолий Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-2-24',
            label: 'НТМиРС_Афонасенко',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-2-24-0',
                label: 'Афонасенко Елена Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-2-25',
            label: 'Инвентарная СУРТС',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-2-25-0',
                label: 'Вольхина Татьяна Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-1',
                label: 'Федотов Иван Юрьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-2',
                label: 'Малофеева Лидия Геннадьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-3',
                label: 'Лобанова Л.М.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-4',
                label: 'Поваренкина Н.В.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-5',
                label: 'Шишковская Марина Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-6',
                label: 'Федотов Александр Михайлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-7',
                label: 'Владимиров Владимир Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-8',
                label: 'Кугаевская Антонина Юрьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-9',
                label: 'Климчук Инна Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-10',
                label: 'Бельков Алексей Юрьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-11',
                label: 'Матус Ирина Васильевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-12',
                label: 'Ким Евгений Васильевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-13',
                label: 'Аранский Иван Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-14',
                label: 'Соловьев Дмитрий Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-15',
                label: 'Алимов Сергей Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-16',
                label: 'Скрынников Виталий Петрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-17',
                label: 'Шкитенкова Людмила Степановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-18',
                label: 'Бистис Павел Юрьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-19',
                label: 'Климчук Инна Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-20',
                label: 'Выголов Константин Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-21',
                label: 'Надыров Радмир Шайхизаманович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-22',
                label: 'Эккерт Александр Алвисович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-23',
                label: 'Николаева Елена Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-24',
                label: 'Леонтьева Татьяна Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-25',
                label: 'Ильина Ксения Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-26',
                label: 'Герасимова Мария Евгеньевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-27',
                label: 'Чилингарашвили Екатерина Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-28',
                label: 'Кушнарев Сергей Анатольевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-29',
                label: 'Мельникова Светлана Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-30',
                label: 'Ковалев Сергей Михайлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-31',
                label: 'Зубкив Светлана Юрьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-32',
                label: 'Толчеев Евгений Евгеньевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-33',
                label: 'Руденко Игорь Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-34',
                label: 'Бородин Олег Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-35',
                label: 'Нижевясов Александр Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-36',
                label: 'Фахриева Эльмира Мавлитьяновна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-37',
                label: 'Буторин Александр Андреевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-38',
                label: 'Каныгин Константин Васильевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-39',
                label: 'Дернов Максим Валерьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-40',
                label: 'Мальцева Елена Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-41',
                label: 'Приходченко Наталья Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-42',
                label: 'Засимова Гюльнара Назировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-43',
                label: 'Яновская Марина Васильевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-44',
                label: 'Григорян Наталья Генриховна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-45',
                label: 'Бажев Беслан Военканович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-46',
                label: 'Молокова Наталья Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-47',
                label: 'Коломийцева Оксана Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-48',
                label: 'Левицкая Татьяна Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-49',
                label: 'Кожушко Ирина Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-50',
                label: 'Полушкина Татьяна Борисовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-51',
                label: 'Смыкова Елизавета Марковна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-52',
                label: 'Фролова Зинаида Павловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-53',
                label: 'Бычков Владислав Геннадьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-54',
                label: 'Королева Марина Геннадьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-55',
                label: 'Шевченко Карина Георгиевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-56',
                label: 'Хевролин Денис Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-57',
                label: 'Диспетчера-смена Юг',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-58',
                label: 'Каргалева Нелли Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-59',
                label: 'Гашенко Сергей Павлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-60',
                label: 'Мокроусов Николай Григорьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-61',
                label: 'Агаджанян Артак Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-62',
                label: 'Ганиева Эльвира Лизмовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-63',
                label: 'Ратушная Елена Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-64',
                label: 'Рябчёнок Александр Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-65',
                label: 'Ротанова Наталья Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-66',
                label: 'Чернец Александр Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-67',
                label: 'Морозов Денис Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-68',
                label: 'Миронов Олег Юрьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-69',
                label: 'Стояни Юрий Федорович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-70',
                label: 'Модин Андрей Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-71',
                label: 'Соколовских Ирина Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-72',
                label: 'Леканова Татьяна Вадимовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-73',
                label: 'Еньшин Владимир Юрьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-74',
                label: 'Кулаков Алексей Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-75',
                label: 'Чернавских Ольга Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-76',
                label: 'Кокорин Вячеслав Юрьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-77',
                label: 'Гончарова Олеся Робертовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-78',
                label: 'Тулянова Кристина Олеговна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-79',
                label: 'Заздравных Татьяна Сергеевна ',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-80',
                label: 'Деменьшина Вера Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-81',
                label: 'Снигирева Наталья Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-82',
                label: 'Зверева Людмила Геннадьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-83',
                label: 'Кузвесова Наталья Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-84',
                label: 'Стрик Александр Анатольевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-85',
                label: 'Катаев Андрей Анатольевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-86',
                label: 'Малофеев Александр Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-87',
                label: 'Романенко Михаил Алексеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-88',
                label: 'Бабак Сергей Федорович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-89',
                label: 'Котельникова Светлана Аркадьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-90',
                label: 'Стариков Евгений Федорович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-91',
                label: 'Загуляев Александр Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-92',
                label: 'Долгушин Алексей Юрьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-93',
                label: 'Пашигорева Татьяна Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-94',
                label: 'Казаков Сергей Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-95',
                label: 'Токарева Оксана Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-96',
                label: 'Пинженин Александр Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-97',
                label: 'Бурцев Илья Игоревич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-98',
                label: 'Шумейко Екатерина Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-25-99',
                label: 'Долгополов Сергей Яковлевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-2-26',
            label: 'ДРОС Урал',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-2-26-0',
                label: 'Калинин Антон Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-2-26-1',
                label: 'Снегин Константин Андреевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          }
        ],
        data: 'Подразделение'
      },
      {
        key: '0-3',
        label: 'НФТС Сибирь',
        icon: 'pi pi-fw pi-cog',
        children: [
          {
            key: '0-3-0',
            label: 'Фил Томский',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-3-0-0',
                label: 'Архипенко Е.Е.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-0-1',
                label: 'Хазова Н.И.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-0-2',
                label: 'Козлов Павел Анатольевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-0-3',
                label: 'Архипенко Елена Евгеньевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-0-4',
                label: 'Пономарева Ирина Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-3-1',
            label: 'Фил Омский',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-3-1-0',
                label: 'Федоренко Екатерина Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-1-1',
                label: 'Конкин Сергей Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-1-2',
                label: 'Меделянова Александра Витальевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-1-3',
                label: 'Гнедая Лада Владиславовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-3-2',
            label: 'Фил Новосибирск',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-3-2-0',
                label: 'Хабло Марина Ивановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-2-1',
                label: 'Копалкина Анна Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-2-2',
                label: 'Мичурина А.С.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-2-3',
                label: 'Мартазова Е.В.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-2-4',
                label: 'Корнеева Н.А.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-2-5',
                label: 'Троцкая Н.Н.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-2-6',
                label: 'Андрес С.Г.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-2-7',
                label: 'Даньшин Евгений Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-2-8',
                label: 'Завьялов Александр Евгеньевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-2-9',
                label: 'Новоселова Юлия Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-2-10',
                label: 'Мартазова Елена Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-2-11',
                label: 'Ерохин Алексей Игоревич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-3-3',
            label: 'Фил Красноярский',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-3-3-0',
                label: 'Яковлева Елена Петровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-3-1',
                label: 'Ржеудский Н.В.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-3-2',
                label: 'Храмов Максим Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-3-3',
                label: 'Шевцов Михаил Валерьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-3-4',
                label: 'Белоусов Артем Андреевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-3-5',
                label: 'Сивкова Светлана Федоровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-3-6',
                label: 'Иванов Дмитрий Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-3-7',
                label: 'Котенёва Алёна Вячеславовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-3-8',
                label: 'Колесникова Наталья николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-3-4',
            label: 'Фил Кемеровский',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-3-4-0',
                label: 'Мухина Евгения Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-4-1',
                label: 'Надежницкая Ирина Альбертовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-4-2',
                label: 'Диулина С.В.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-4-3',
                label: 'Просвиркина Т.В.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-4-4',
                label: 'Боровик Елена Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-4-5',
                label: 'Сарапулов Максим Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-4-6',
                label: 'Желандинова Надежда Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-4-7',
                label: 'Логинов Степан Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-4-8',
                label: 'Григорьева Ирина Ивановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-3-5',
            label: 'Фил Иркутский',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-3-5-0',
                label: 'Татаркин Алексей Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-5-1',
                label: 'Тарабан Г.А.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-5-2',
                label: 'Жукова И.А.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-5-3',
                label: 'Шпунт Татьяна Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-5-4',
                label: 'Габайдуллина Танзиля Хабибулловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-5-5',
                label: 'Пластинина Юлия Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-5-6',
                label: 'Романова Наталья Ивановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-5-7',
                label: 'Верхозина Екатерина Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-5-8',
                label: 'Леонова Евгения Алексеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-5-9',
                label: 'Петрович Лолита Романовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-3-6',
            label: 'Фил Бурятский',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-3-6-0',
                label: 'Шолохова И.В.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-6-1',
                label: 'Сидинкина И.В.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-6-2',
                label: 'Нетесова О.И.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-6-3',
                label: 'Павлова О.Н.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-6-4',
                label: 'Порсева В.В.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-6-5',
                label: 'Лобсанов Чингис Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-6-6',
                label: 'Шестакова Светлана Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-6-7',
                label: 'Косикова Евгения Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-6-8',
                label: 'Гармаева Эржена Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-6-9',
                label: 'Сидинкина Ирина Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-6-10',
                label: 'Спиридонов Дмитрий Павлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-3-7',
            label: 'Фил Алтайский',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-3-7-0',
                label: 'Звягинцева О.П.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-7-1',
                label: 'Ердакова Людмила Ефимовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-7-2',
                label: 'Таманов Игорь Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-7-3',
                label: 'Колеватых Александр Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-7-4',
                label: 'Головченко Юрий Кузьмич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-3-8',
            label: 'НТМиРС_Скорик',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-3-8-0',
                label: 'Скорик Елена Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-3-9',
            label: 'НТМиРС_Пронина',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-3-9-0',
                label: 'Пронина Евгения Валерьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-3-10',
            label: 'НТМиРС_Назаров',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-3-10-0',
                label: 'Назаров Андрей Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-3-11',
            label: 'НТМиРС_Казанцев',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-3-11-0',
                label: 'Казанцев Константин Иванович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-3-12',
            label: 'НТМиРС_Иванцов',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-3-12-0',
                label: 'Иванцов Александр Георгиевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-3-13',
            label: 'НТМиРС_Дурова',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-3-13-0',
                label: 'Дурова Галина Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-3-14',
            label: 'НТМиРС_Гавриленко',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-3-14-0',
                label: 'Гавриленко Семен Витальевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-3-15',
            label: 'НТМиРС_Волобуев',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-3-15-0',
                label: 'Волобуев Михаил Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-3-16',
            label: 'НТМиРС_Борисов',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-3-16-0',
                label: 'Борисов Виктор Юрьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-3-17',
            label: 'Инвентарная СУРТС',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-3-17-0',
                label: 'Жукова Раиса Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-1',
                label: 'Арышева Надежда Витальевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-2',
                label: 'Шубкин Вячеслав Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-3',
                label: 'Кузнецова Татьяна Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-4',
                label: 'Бизина Вера Геннадьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-5',
                label: 'Борзило Максим Леонидович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-6',
                label: 'Цветошина Татьяна Евгеньевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-7',
                label: 'Слуянова Ирина Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-8',
                label: 'Борисова Светлана Валентиновна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-9',
                label: 'Никишина Валентина Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-10',
                label: 'Лутков Дмитрий Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-11',
                label: 'Дудченко Дмитрий Вячеславович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-12',
                label: 'Тирских Дмитрий Анатольевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-13',
                label: 'Шутов Антон Петрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-14',
                label: 'Трошкин Евгений Борисович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-15',
                label: 'Зиленина Лариса Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-16',
                label: 'Кабанова Ольга Петровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-17',
                label: 'Клинг Дмитрий Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-18',
                label: 'Самородова Зинаида Акчаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-19',
                label: 'Ильченко Елена Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-20',
                label: 'Поддубный Юрий Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-21',
                label: 'Шерин Алексей Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-22',
                label: 'Копейкина Елена Валентиновна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-23',
                label: 'Аристова Марина Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-24',
                label: 'Латышев Сергей Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-25',
                label: 'Лебедев Дмитрий Олегович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-26',
                label: 'Лосенков Андрей Антонович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-27',
                label: 'Николаева Людмила Николаена',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-28',
                label: 'Старушик Елена Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-29',
                label: 'Базелюк Михаил Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-30',
                label: 'Доржиева Туяна Мункожаргаловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-31',
                label: 'Дашеев Арсалан Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-32',
                label: 'Самородова Зинаида Акчаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-33',
                label: 'Сакевич Николай Эдуардович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-34',
                label: 'Цадер Наталья Сбигневна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-35',
                label: 'Исыпова Татьяна Борисовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-36',
                label: 'Дрыгина Светлана Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-37',
                label: 'Печерина Ольга Рамозановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-38',
                label: 'Матвиенко Андрей Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-39',
                label: 'Мизонова Светлана Юрьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-40',
                label: 'Пикуров Виктор Евгеньевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-41',
                label: 'Михалев Владимир Михайлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-42',
                label: 'Колесник Василий Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-43',
                label: 'Крнейчук Михаил Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-44',
                label: 'Кульгин Юрий Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-45',
                label: 'Соколова Елена Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-46',
                label: 'Хуторянский Евгений Маркович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-47',
                label: 'Куроедов Виктор Степанович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-48',
                label: 'Васильев Максим Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-49',
                label: 'Кузнецов Игорь Иванович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-50',
                label: 'Лубнин Виталий Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-51',
                label: 'Боженов Евгений Юрьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-52',
                label: 'Старцев Александр Алексеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-53',
                label: 'Гаврилова Ольга Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-54',
                label: 'Савкин Сергей Юрьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-55',
                label: 'Хам Алексей Денхванович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-56',
                label: 'Бызова Светлана Валерьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-57',
                label: 'Иваненко Инна Алексеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-58',
                label: 'Миндияров Александр Раисович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-59',
                label: 'Галанина Светлана Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-60',
                label: 'Татаринцева Светлана Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-61',
                label: 'Лакуцевич Елена Гурьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-62',
                label: 'Зизевский Игорь Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-63',
                label: 'Занхоев Григорий Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-64',
                label: 'Григорьев Максим Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-65',
                label: 'Скородинская Ирина Евгеньевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-66',
                label: 'Рыков Вадим Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-67',
                label: 'Куроедова Любовь Георгиевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-68',
                label: 'Забобонин Александр Петрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-69',
                label: 'Коваленко Валерий Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-70',
                label: 'Василенко Юрий Иванович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-71',
                label: 'Нестеров Денис Игоревич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-72',
                label: 'Желандингова Надежда Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-73',
                label: 'Мальцева Наталия Витальевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-74',
                label: 'Мальцева Наталия Витальевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-75',
                label: 'Семягина Лиана Евгеньевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-76',
                label: 'Попов Павел Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-77',
                label: 'Садовая Елена Юрьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-78',
                label: 'Абенд Вадим Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-79',
                label: 'Коптева Елена Васильевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-80',
                label: 'Лузгина Татьяна Владимровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-81',
                label: 'Мельничук Елена Петровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-82',
                label: 'Соина Ольга Евгеньевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-83',
                label: 'Смышляева Галина Геннадьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-3-17-84',
                label: 'Акзамова Мария Евгеньевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-3-18',
            label: 'ДРОС Сибирь',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-3-18-0',
                label: 'Титова Лидия Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-3-19',
            label: ' Дирекция',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-3-19-0',
                label: 'Захваткин Сергей Валерьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          }
        ],
        data: 'Подразделение'
      },
      {
        key: '0-4',
        label: 'НФТС Северо-Запад',
        icon: 'pi pi-fw pi-cog',
        children: [
          {
            key: '0-4-0',
            label: 'Фил Новг и Псков',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-4-0-0',
                label: 'Гандалоев Андрей Вахавич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-0-1',
                label: 'Агбабишвили Марина Валентиновна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-0-2',
                label: 'Гиллер Ольга Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-0-3',
                label: 'Покрышко Ольга Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-0-4',
                label: 'Ефремова Алена Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-0-5',
                label: 'Морозова Светлана Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-0-6',
                label: 'Мульская Вера Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-0-7',
                label: 'Ступар Мария Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-0-8',
                label: 'Полева Анастасия Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-0-9',
                label: 'Вавилин Игорь Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-0-10',
                label: 'Карабанов Дмитрий Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-0-11',
                label: 'Малахова Любовь Евгеньевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-0-12',
                label: 'Васянина Наталья Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-0-13',
                label: 'Лаврентьев Сергей Аркадьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-4-1',
            label: 'Фил Мурманск',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-4-1-0',
                label: 'Пискунова О.Н. (Радостева)',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-1-1',
                label: 'Иванов Павел Валерьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-1-2',
                label: 'Прахова Инна Юрьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-1-3',
                label: 'Пискунова Ольга Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-1-4',
                label: 'Таносенко Анастасия Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-1-5',
                label: 'Прогрущенко Татьяна Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-1-6',
                label: 'Ерофеев Алексей Иванович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-4-2',
            label: 'Фил Коми',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-4-2-0',
                label: 'Лыюрова Елена Алексеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-2-1',
                label: 'Зенкова Наталья Леонидовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-2-2',
                label: 'Конюхов Олег Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-2-3',
                label: 'Ляшев Сергей Алексеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-2-4',
                label: 'Паплинская Светлана Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-2-5',
                label: 'Маркова Зоя Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-2-6',
                label: 'Пузыревский Константин Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-4-3',
            label: 'Фил Карельский',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-4-3-0',
                label: 'Савельев Иван Олегович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-3-1',
                label: 'Савостина Роза Петровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-3-2',
                label: 'Гормакова Татьяна Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-3-3',
                label: 'Леонтьева Ольга Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-3-4',
                label: 'Пухальская Татьяна Леонидовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-3-5',
                label: 'Борейшо Ирина Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-4-4',
            label: 'Фил Калининград',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-4-4-0',
                label: 'Винс Елена Григорьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-4-1',
                label: 'Гаевский Сергей Валериевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-4-2',
                label: 'Тронина Агния Георгиевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-4-3',
                label: 'Сахарова Галина Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-4-5',
            label: 'Фил Вологодский',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-4-5-0',
                label: 'Федотов Виталий Михайлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-5-1',
                label: 'Круглова Ирина Алексеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-5-2',
                label: 'Кумачёва Надежда Борисовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-5-3',
                label: 'Шилов Леонид Валентинович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-4-6',
            label: 'Фил Архангельск',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-4-6-0',
                label: 'Владимирова Елена Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-6-1',
                label: 'Опякина Валентина Васильевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-4-7',
            label: 'НФТС',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-4-7-0',
                label: 'Тян Виктория Алексеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-4-8',
            label: 'НТУМС Новгородский филиал',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-4-8-0',
                label: 'Бабкина Елена Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-4-9',
            label: 'НТУМС Вологодский филиал',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-4-9-0',
                label: 'Адоминене Анастасия Леонидовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-9-1',
                label: 'Шаров Даниил Олегович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-4-10',
            label: 'Инвентарная СУРТС',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-4-10-0',
                label: 'Семенчик Галина Дмитриевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-1',
                label: 'Филатов Николай Павлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-2',
                label: 'Стойко Светлана Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-3',
                label: 'Кулиш Николай Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-4',
                label: 'Сорокин Алексей Георгиевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-5',
                label: 'Колышкин Александр Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-6',
                label: 'Цицилин Александр Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-7',
                label: 'Заварин Алексей николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-8',
                label: 'Лебедев Александр Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-9',
                label: 'Ванюков Александр Евгеньевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-10',
                label: 'Иванов Александр Михайлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-11',
                label: 'Дуркин Анатолий Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-12',
                label: 'Буйный Андрей Васильевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-13',
                label: 'Игнашев Андрей Анатольевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-14',
                label: 'Вашуков Андрей Валерьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-15',
                label: 'Рафальский Дмитрий Михайлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-16',
                label: 'Мироничева Елена Ивановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-17',
                label: 'Глухов Евгений Юрьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-18',
                label: 'Фискин Евгений Леонидович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-19',
                label: 'Сахарова Галина Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-20',
                label: 'Ракитин Геннадий Васильевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-21',
                label: 'Королев Игорь Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-22',
                label: 'Ковальчук Игорь  Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-23',
                label: 'Орлова Ирина Львовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-24',
                label: 'Смирнов Константин Геннадьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-25',
                label: 'Рогозина Лариса Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-26',
                label: 'Барабан Леонид Абрамович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-27',
                label: 'Зиновьева Наталия Васильевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-28',
                label: 'Ширшова Наталья Валентиновна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-29',
                label: 'Суховей Наталья Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-30',
                label: 'Гребенев Николай Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-31',
                label: 'Решетник Николай Васильевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-32',
                label: 'Постникова Ольга Ивановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-33',
                label: 'Стяшкович Ольга Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-34',
                label: 'Андриянова Ольга Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-35',
                label: 'Щедров Павел Игоревич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-36',
                label: 'Мукминов Руслан Сайфуллович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-37',
                label: 'Андрушкевич Светлана Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-38',
                label: 'Коровкин Сергей Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-39',
                label: 'Иванов Сергей Дмитриевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-40',
                label: 'Чертополохов Сергей Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-41',
                label: 'Ботка Сергей Анатольевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-42',
                label: 'Максимов Сергей Леонидович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-43',
                label: 'Дьяков Сергей Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-44',
                label: 'Якубович Сергей Алексеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-45',
                label: 'Сидорова Светлана Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-46',
                label: 'Баркасова Татьяна Алевтиновна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-47',
                label: 'Клюшина Татьяна Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-48',
                label: 'Лихачев Виктор Георгиевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-49',
                label: 'Алексеев Валерий Ремович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-50',
                label: 'Игнатьев Владимир Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-51',
                label: 'Хохлов Владимир Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-52',
                label: 'Автонеева Юлия Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-53',
                label: 'Слуцкий Владимир Михайлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-54',
                label: 'Папакина Елена Валерьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-55',
                label: 'Бехтольд Инесса Виктовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-56',
                label: 'Валетова Юлия Вячеславовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-57',
                label: 'Ефремов Виктор Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-58',
                label: 'Кублицкий Станислав Евгеньевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-59',
                label: 'Маркова Марина Игоревна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-60',
                label: 'Абдряхимов Рустам Равильевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-61',
                label: 'Афонина Ольга Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-62',
                label: 'Коновалова Юлия Леонидовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-63',
                label: 'Попова Мария Геннадьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-64',
                label: 'Бибичева Юлия Вадимовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-65',
                label: 'Дерябина Наталья Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-66',
                label: 'Цицилина Ирина Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-67',
                label: 'Конторина Надежда Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-68',
                label: 'Литвинов Елисей Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-69',
                label: 'Берникова Елена Адамовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-70',
                label: 'Кудрявцева Любовь Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-71',
                label: 'Трубина Анна Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-72',
                label: 'Андреева Ирина Евгеньевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-73',
                label: 'Ерофеевская Татьяна Ивановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-74',
                label: 'Кочергин Владимир Иванович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-75',
                label: 'Чигирь Татьяна Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-76',
                label: 'Слепухина Людмила Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-77',
                label: 'Ханкишиева Елена Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-78',
                label: 'Тюрикова Раиса Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-79',
                label: 'Недобуга Сергей Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-80',
                label: 'Михайлова Ольга Петровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-81',
                label: 'Варфоломеев Алексей Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-82',
                label: 'Воробьев Николай Иванович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-83',
                label: 'Круглецкая Татьяна Витальевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-84',
                label: 'Андронова Любовь Юрьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-85',
                label: 'Овсянникова Лариса Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-86',
                label: 'Хазов Михаил Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-87',
                label: 'Лавринович Денис Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-88',
                label: 'Воробьев Александр Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-89',
                label: 'Смена СМССиИС РЦУСС',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-90',
                label: 'Чебыкин Алексей Геннадьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-91',
                label: 'Василевский Тимур Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-92',
                label: 'Демидов Валерий Юрьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-93',
                label: 'Юшманов Евгений Витальевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-94',
                label: 'Донец Алексей Валерьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-95',
                label: 'Кошкина Наталья Васильевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-96',
                label: 'Киселев Сергей Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-97',
                label: 'Степанов Дмитрий Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-98',
                label: 'Мосалев Родион Михайлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-99',
                label: 'Пленокос Людмила Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-100',
                label: 'Зиновьева Наталия Васильевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-101',
                label: 'Кизуб Светлана Петровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-102',
                label: 'Тамеев Артем Фаргатович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-103',
                label: 'Смирнов Максим Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-104',
                label: 'Данилов Александр Михайлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-105',
                label: 'Лукьянов Александр Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-106',
                label: 'Ильинский Александр Вадимович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-107',
                label: 'Малахов Иван Вячеславович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-108',
                label: 'Лисиченко Иван Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-109',
                label: 'Бирюкова Валентина Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-110',
                label: 'Возная Ирина Ивановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-111',
                label: 'Дружинин Константин Вячеславович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-112',
                label: 'Пьянкова Лариса Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-113',
                label: 'Тюрина Елена Семеновна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-10-114',
                label: 'Антонова Ольга Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-4-11',
            label: 'ДЭТИ',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-4-11-0',
                label: 'Садовниченко Ольга Васильевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-11-1',
                label: 'Сахарова Ольга Юрьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-11-2',
                label: 'Ходаковская Людмила Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-4-11-3',
                label: 'Долженкова Людмила Ивановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          }
        ],
        data: 'Подразделение'
      },
      {
        key: '0-5',
        label: 'НФТС Дальний Восток',
        icon: 'pi pi-fw pi-cog',
        children: [
          {
            key: '0-5-0',
            label: 'Фил Хабаровский',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-5-0-0',
                label: 'Климова Альбина Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-0-1',
                label: 'Крячек Светлана Юрьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-0-2',
                label: 'Литвакова Надежда Валентиновна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-0-3',
                label: 'Ульянкина Ирина Ярославовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-0-4',
                label: 'Паюсова Ольга Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-5-1',
            label: 'Фил Сахателеком',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-5-1-0',
                label: 'Сивцева М.Н.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-1-1',
                label: 'Колодезникова Елена Гекторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-1-2',
                label: 'Николаева Алёна Федоровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-5-2',
            label: 'Фил Сахалинский',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-5-2-0',
                label: 'Исупова Светлана Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-2-1',
                label: 'Толмашенко Валентина Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-2-2',
                label: 'Васильев Виктор Евгеньевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-5-3',
            label: 'Фил Приморский',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-5-3-0',
                label: 'Колотенко Ирина Ивановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-3-1',
                label: 'Кропотова Ольга Ивановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-3-2',
                label: 'Кравцова Елена Юрьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-3-3',
                label: 'Боченко Николай Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-3-4',
                label: 'Кабенкина  Наталья Георгиевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-3-5',
                label: 'Важенина Светлана Алексеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-5-4',
            label: 'Фил Магаданский',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-5-4-0',
                label: 'Алексютина Ирина Георгиевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-4-1',
                label: 'Кухаренко Светлана Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-5-5',
            label: 'Фил Камчатский',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-5-5-0',
                label: 'Выговская Нина Константиновна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-5-1',
                label: 'Боровикова Ирина Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-5-6',
            label: 'Фил Амурский',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-5-6-0',
                label: 'Никитин Дмитрий Анатольевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-6-1',
                label: 'Гетьман Ирина Григорьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-6-2',
                label: 'Иванова Маргарита Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-6-3',
                label: 'Лакиза Лилия Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-6-4',
                label: 'Ашурова Юлия Леонидовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-5-7',
            label: 'НТУМС Дальний Восток',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-5-7-0',
                label: 'Полянская Вера Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-7-1',
                label: 'Бородич Ирина Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-7-2',
                label: 'Адамович Ирина Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-5-8',
            label: 'НТМиРС_Щербакова',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-5-8-0',
                label: 'Щербакова Александра Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-5-9',
            label: 'НТМиРС_Шокуров',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-5-9-0',
                label: 'Шокуров Илья Валерьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-5-10',
            label: 'НТМиРС_Свечкова',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-5-10-0',
                label: 'Свечкова Евгения Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-5-11',
            label: 'НТМиРС_Ревенок',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-5-11-0',
                label: 'Ревенок Инна Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-5-12',
            label: 'НТМиРС_Макарова',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-5-12-0',
                label: 'Макарова Елена Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-5-13',
            label: 'НТМиРС_Ворожейкина',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-5-13-0',
                label: 'Ворожейкина Елена Васильевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-5-14',
            label: 'НТМиРС_Владимиров',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-5-14-0',
                label: 'Владимиров Александр Васильевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-5-15',
            label: 'Инвентарная СУРТС',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-5-15-0',
                label: 'Кошокина Наталья Леонидовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-1',
                label: 'Перепелица Александр Дмитриевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-2',
                label: 'Сухин Вячеслав Васильевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-3',
                label: 'Колесникова Светлана Валерьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-4',
                label: 'Сорока Владимир Валерьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-5',
                label: 'Прилепина Елена Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-6',
                label: 'Мироненко Татьяна Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-7',
                label: 'Сивцева Марианна Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-8',
                label: 'Олейникова Галина Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-9',
                label: 'Панов Александр Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-10',
                label: 'Клюшенков Леонид Станиславович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-11',
                label: 'Соковец Светлана Брониславовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-12',
                label: 'Строганов Вячеслав Валерьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-13',
                label: 'Силка Виталий Анатольевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-14',
                label: 'Янукова Людмила Григорьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-15',
                label: 'Бузланова Ольга Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-16',
                label: 'Деньга Виталий Геннадьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-17',
                label: 'Григорьева Лариса Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-18',
                label: 'Рябуха Полина Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-19',
                label: 'Шумских Ольга Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-20',
                label: 'Ткаченко Александр Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-21',
                label: 'Малиновская Светлана Станиславовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-22',
                label: 'Шкуратова Татьяна Ивановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-23',
                label: 'Савкина Лидия Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-24',
                label: 'Мищенко Мира Алексеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-25',
                label: 'Люкшина Наталья Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-26',
                label: 'Лянная Виктория Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-27',
                label: 'Бондаренко Светлана Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-28',
                label: 'Бородич Ирина Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-29',
                label: 'Дубова Ольга Ивановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-30',
                label: 'Смена УП15120',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-31',
                label: 'Цымбалист Вера Фёдоровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-32',
                label: 'Черепина Елена Павловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-33',
                label: 'Аверина Елена Валерьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-34',
                label: 'смена СМССиИС РЦУСС',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-35',
                label: 'смена СМССиИС РЦУСС',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-36',
                label: 'смена СМССиИС РЦУСС',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-37',
                label: 'Тимофеева Мария Аркадьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-38',
                label: 'Круш Людмила Васильевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-39',
                label: 'Шепеленко Елена Андреевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-40',
                label: 'Леликов Юрий Валерьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-41',
                label: 'Слатвинская Елена Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-42',
                label: 'Левицкий Игорь Олегович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-43',
                label: 'Мезенин Владимир Владимир',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-44',
                label: 'Яснюк Юрий Григорьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-45',
                label: 'Орёл Сергей Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-15-46',
                label: 'Ананенко Светлана Вячеславовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-5-16',
            label: 'ДРОС ДВ',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-5-16-0',
                label: 'Пак Эдуард Минсунович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-16-1',
                label: 'Сергеенко Екатерина Ильинична',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-5-16-2',
                label: 'Колесников Михаил Валерьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          }
        ],
        data: 'Подразделение'
      },
      {
        key: '0-6',
        label: 'НФТС Волга',
        icon: 'pi pi-fw pi-cog',
        children: [
          {
            key: '0-6-0',
            label: 'Филиал в республике Татарстан',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-6-0-0',
                label: 'Хайруллин Ильгизар Самикович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-6-1',
            label: 'Фил Ульяновский',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-6-1-0',
                label: 'Хайрулин Эльдар Искэндэрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-6-2',
            label: 'Схемы (МРФ Волга)',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-6-2-0',
                label: 'Цвирко Виктория Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-6-3',
            label: 'Самарский филиал',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-6-3-0',
                label: 'Коннова татьяна Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-6-4',
            label: 'Пензенский филиал',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-6-4-0',
                label: 'Корчагина Ирина Рудольфовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-4-1',
                label: 'Шитиков Валерий Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-4-2',
                label: 'Борисов Александр Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-4-3',
                label: 'Пашкин Сергей Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-4-4',
                label: 'Дегтярев Валерий Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-6-5',
            label: 'Оренбургский филиал',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-6-5-0',
                label: 'Сорокин Вячеслав Германович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-5-1',
                label: 'Добреля Олег Михайлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-5-2',
                label: 'Кужамбетова Гульбаршин Жубаткановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-5-3',
                label: 'Иванов Александр Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-5-4',
                label: 'Шипицына Елена Борисовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-5-5',
                label: 'Синотова Надежда Алексеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-5-6',
                label: 'Насыбулин Ильяс Ильгизарович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-5-7',
                label: 'Гинкель Дмитрий Артурович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-5-8',
                label: 'Нерезенко Александра Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-5-9',
                label: 'Канарейкина Юлия Юрьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-5-10',
                label: 'Феллер Виктор Иосифович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-5-11',
                label: 'Гололобова Светлана Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-6-6',
            label: 'ОАУиФС ЦБД',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-6-6-0',
                label: 'Зимина Анастасия Вячеславовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-6-7',
            label: 'НТМиРС_Старков ВА',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-6-7-0',
                label: 'Старков Виктор Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-6-8',
            label: 'НТМиРС_Серебренников ВВ',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-6-8-0',
                label: 'Серебренников Валерий Вадимович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-6-9',
            label: 'НТМиРС_Семёнов СИ',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-6-9-0',
                label: 'Семёнов Сергей Иванович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-6-10',
            label: 'НТМиРС_Самойлов ЕК',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-6-10-0',
                label: 'Самойлов Евгений Константинович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-6-11',
            label: 'НТМиРС_Орлов ДВ',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-6-11-0',
                label: 'Орлов Дмитрий Витольдович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-6-12',
            label: 'НТМиРС_Мухамадиев ЗР',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-6-12-0',
                label: 'Мухамадиев Зуфар Ромазанович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-6-13',
            label: 'НТМиРС_Махмудов РМ',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-6-13-0',
                label: 'Махмудов Радиф Маратович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-6-14',
            label: 'НТМиРС_Максумов АР',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-6-14-0',
                label: 'Максумов Аслан Равшанович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-6-15',
            label: 'НТМиРС_Куракин МС',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-6-15-0',
                label: 'Куракин Максим Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-6-16',
            label: 'НТМиРС_Коннов ПА',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-6-16-0',
                label: 'Коннов Петр Алексеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-6-17',
            label: 'НТМиРС_Зубов АВ',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-6-17-0',
                label: 'Зубов Алексей Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-6-18',
            label: 'НТМиРС_Григорьева РБ',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-6-18-0',
                label: 'Григорьева Регина Булатовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-6-19',
            label: 'НТМиРС_Гильмутдинов РР',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-6-19-0',
                label: 'Гильмутдинов Ринат Ришатович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-6-20',
            label: 'НТМиРС_Бойцов АО',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-6-20-0',
                label: 'Бойцов Артем Олегович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-6-21',
            label: 'НТМиРС_Абрамова НВ',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-6-21-0',
                label: 'Абрамова Наталья Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-6-22',
            label: 'МордовияРФ',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-6-22-0',
                label: 'Шушпанов Александр Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-22-1',
                label: 'Алышева Элина Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-22-2',
                label: 'Гордеев Лев Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-6-23',
            label: 'Кировский филиал',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-6-23-0',
                label: 'Круглов Дмитрий Евгеньевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-23-1',
                label: 'Поздеева Светлана Игоревна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-6-24',
            label: 'Инвентарная СУРТС',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-6-24-0',
                label: 'Кадиров Фаяз Хайдарович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-1',
                label: 'Пищулин Александр Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-2',
                label: 'Маклыгин Сергей Викентьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-3',
                label: 'Блайберг Дмитрий Вячеславовоич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-4',
                label: 'Чевтайкин Игорь Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-5',
                label: 'Арискина Дарья Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-6',
                label: 'Капранова Галина Павловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-7',
                label: 'Иванова Марина Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-8',
                label: 'Горинов Николай Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-9',
                label: 'Булгакова Наталья Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-10',
                label: 'Филиппова Тамара Давыдовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-11',
                label: 'Кочешкова Мария Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-12',
                label: 'Гаврилова Вера Павловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-13',
                label: 'Баранов Андрей Юрьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-14',
                label: 'Ермакова Антонина Вениаминовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-15',
                label: 'Лекторович Татьяна Ивановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-16',
                label: 'Фокина Татьяна Алексеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-17',
                label: 'Григорьевых Елена Андреевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-18',
                label: 'Чурбанов Игорь Анатольевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-19',
                label: 'Алексеева Людмила Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-20',
                label: 'Аверин Михаил Васильевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-21',
                label: 'Тухветьева Раиля Миниахметовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-22',
                label: 'Мерзляков Роман Игоревич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-23',
                label: 'Селюнин Виктор Михайлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-24',
                label: 'Егоров Александр Валерьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-25',
                label: 'Ярцев Павел Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-26',
                label: 'Горбенко Елена Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-27',
                label: 'Хакимов Айрат Талгатович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-28',
                label: 'Ивойлов Владимир Геннадьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-29',
                label: 'Недочетов Константин Юрьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-30',
                label: 'Токарев Игорь Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-31',
                label: 'Головчанская Галина Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-32',
                label: 'сменный инженер ОМССиИС МРЦУССиИС',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-33',
                label: 'сменный инженер ОМССиИС МРЦУССиИС',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-34',
                label: 'Апанаева Елена Вячеславовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-35',
                label: 'Фадеева Елена Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-36',
                label: 'Сороколадова Татьяна Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-37',
                label: 'Прохорова Елена Константиновна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-38',
                label: 'Бидзан Ольга Арсентьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-39',
                label: 'Веселовская Татьяна Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-40',
                label: 'Баранова Марина Валерьяновна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-41',
                label: 'Кузнецова Людмила Геннадьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-42',
                label: 'Панина Татьяна Вячеславовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-43',
                label: 'Усанова Вера Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-44',
                label: 'Хрисанова Елена Петровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-45',
                label: 'Никитина Ираида Петровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-46',
                label: 'Шадрин Александр Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-47',
                label: 'Измайлова Елена Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-48',
                label: 'Аникина Наталья Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-49',
                label: 'Мехонцев Владимир Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-50',
                label: 'Пантелеева Анна Витальевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-51',
                label: 'Лапшова Елена Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-52',
                label: 'Моисеев Валентин Юрьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-53',
                label: 'Моисеев Александр Юрьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-54',
                label: 'Маноскина Маргарита Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-55',
                label: 'Сахненко Татьяна Валерьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-56',
                label: 'Астафьева Ольга Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-57',
                label: 'Челединова Рузалина Ильдусовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-58',
                label: 'Харисова Нурия Тимургалиевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-59',
                label: 'Мншагеев Марат Ильясович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-60',
                label: 'Мишин Сергей Геннадьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-61',
                label: 'Николаева Ирина Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-62',
                label: 'Галимов Айдар Шамилевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-63',
                label: 'Елистратова Елена Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-64',
                label: 'Алексеева Светлана Геннадьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-65',
                label: 'Лисин Анатолий Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-66',
                label: 'Угланова Светлана Вадимовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-67',
                label: 'Гайдукова Ольга Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-68',
                label: 'Иванов Артем Юрьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-69',
                label: 'Рябушкина Наталья Ивановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-70',
                label: 'Ильина Татьяна Леонидовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-71',
                label: 'Кумирова Ксения Валерьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-72',
                label: 'Котельникова Екатерина Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-73',
                label: 'Костяев Сергей Юрьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-74',
                label: 'Михайлова Ольга Вячеславовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-75',
                label: 'Евдокимова Светлана Львовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-76',
                label: 'Аксенова Ольга Федоровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-77',
                label: 'Мурзаев Андрей Николаевич ',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-78',
                label: 'Степанова Юлия Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-79',
                label: 'Семенцова Светлана Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-80',
                label: 'Осинина Юлия Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-81',
                label: 'Луканов Максим Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-82',
                label: 'Траянова Екатерина Борисовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-83',
                label: 'Лудина Екатерина Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-84',
                label: 'Григорьева Любовь Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-85',
                label: 'Степанова Мария Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-86',
                label: 'Алехина Оксана Алексеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-87',
                label: 'Осипова Нина Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-88',
                label: 'Корольков Александр Станиславович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-89',
                label: 'Гусева Анастасия Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-90',
                label: 'Просвирнина Ольга Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-91',
                label: 'Гимаев Альгис Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-92',
                label: 'Гурьянов Сергей Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-93',
                label: 'Силантьев Павел Михайлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-94',
                label: 'Кузьмин Олег Валерьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-95',
                label: 'Фадеева Екатерина Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-96',
                label: 'Анасенков Андрей Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-97',
                label: 'Чигасова Анна Петровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-98',
                label: 'Хрисанов Елена Петровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-99',
                label: 'Дарвина Наталия Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-100',
                label: 'Кузнецова Людмила Геннадьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-101',
                label: 'Ермакова Антонина Вениаминовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-102',
                label: 'Угрюмова Анна Васильевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-103',
                label: 'Бурлака Екатерина Веньяминовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-104',
                label: 'Мухаматкильдин Рамис Ринатович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-105',
                label: 'Кузовкова Елена Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-106',
                label: 'Пришляк Оксана Богдановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-107',
                label: 'Егорова Ирина Борисовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-108',
                label: 'Ткачева Юлия Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-109',
                label: 'Щиголева Галина Евгеньевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-110',
                label: 'Лапшова Наталья Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-111',
                label: 'Киселёв Максим Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-112',
                label: 'Майбородюк Даниил Геннадьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-113',
                label: 'Карицкий Виталий Олегович ',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-114',
                label: 'Самохвалова Ирина Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-115',
                label: 'Ежков Илья Дмитриевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-116',
                label: 'Рыбин Вадим Леонидович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-117',
                label: 'Бутняков Алексей Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-118',
                label: 'Медьков Игорь Евгеньевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-119',
                label: 'Гамберова Нина Васильевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-120',
                label: 'Егорова Татьяна Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-121',
                label: 'Степанов Валерий Валентинович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-122',
                label: 'Боронин Павел Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-123',
                label: 'Мухамедов Назип Носихович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-124',
                label: 'Федоров Егор Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-125',
                label: 'Куимов Алексей Леонидович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-126',
                label: 'Морев Виталий Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-24-127',
                label: 'Куликов Михаил Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-6-25',
            label: 'ГУТС (МРФ Волга)',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-6-25-0',
                label: 'Ерусланова Анна Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-25-1',
                label: 'Ермаков Андрей Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-6-25-2',
                label: 'Самойлов Евгений Константинович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          }
        ],
        data: 'Подразделение'
      },
      {
        key: '0-7',
        label: 'КЦ',
        icon: 'pi pi-fw pi-cog',
        children: [
          {
            key: '0-7-0',
            label: 'ТЦКПМТ МРФ Центр',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-7-0-0',
                label: 'Грицаев Игорь Владиславович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-0-1',
                label: 'Пользователь ТЦКПМТ МРФ Центр',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-0-2',
                label: 'Сугробова Виктория Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-7-1',
            label: 'ПРСГП',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-7-1-0',
                label: 'Адраев Сергей Алексеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-1-1',
                label: 'Жебраков Андрей Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-1-2',
                label: 'Селютин Александр Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-1-3',
                label: 'Здобникова Светлана Витальевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-1-4',
                label: 'Алексеенко Вера Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-1-5',
                label: 'Винокурова Марина Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-1-6',
                label: 'Евдокимова Елена Валентиновна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-1-7',
                label: 'Левченко Дмитрий Валерьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-7-2',
            label: 'ОПМС ДПС',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-7-2-0',
                label: 'Гуркин Дмитрий Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-7-3',
            label: 'ОПИГИС',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-7-3-0',
                label: 'Кандала Юлия Юрьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-7-4',
            label: 'Опер.Дежурный',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-7-4-0',
                label: 'Небоженко Лариса Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-1',
                label: 'Оперативный дежурный',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-2',
                label: 'Почта ЦУ ЦСП СИТП',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-3',
                label: 'Почта ЦУСС-оперативный дежурный',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-4',
                label: 'Почта ЦУСС-ТВ,ЗВ',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-5',
                label: 'Глушенко Татьяна Дмитриевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-6',
                label: 'Лазарев Андрей Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-7',
                label: 'Денисова Наталья Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-8',
                label: 'Резинкин Роман Иванович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-9',
                label: 'Литвинов Роман Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-10',
                label: 'Конюхов Алексей Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-11',
                label: 'Диянский Олег Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-12',
                label: 'Некрасова Ирина Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-13',
                label: 'Пушкарь Олег Григорьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-14',
                label: 'Гартлиб Матвей Андреевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-15',
                label: 'Кучер Марина Станиславовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-16',
                label: 'Кущенко Вадим Игоревич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-17',
                label: 'Грекова Наталья Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-18',
                label: 'Кривцов Владимир Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-19',
                label: 'Насырова Галина Федоровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-20',
                label: 'Шарова Елена Васильевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-21',
                label: 'Грибачева Елена Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-22',
                label: 'Трочинская Светлана Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-23',
                label: 'Гречаная Дарья Евгеньевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-24',
                label: 'Храмцова Ольга Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-25',
                label: 'Петрова Ирина Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-26',
                label: 'Михно Игорь Евгеньевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-27',
                label: 'Буц Александра Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-28',
                label: 'Щеглакова Марина Павловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-29',
                label: 'Калинина Александра Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-30',
                label: 'Глотов Григорий Андреевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-31',
                label: 'Усик Артём Андреевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-4-32',
                label: ' Каныгина Оксана Александровна ',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-7-5',
            label: 'ОАФУIPССКП ДАФУ',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-7-5-0',
                label: 'Орлова Ольга Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-7-6',
            label: 'ОАТС ДАСС',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-7-6-0',
                label: 'Вакс Эдуард Михайлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-7-7',
            label: 'НФТС УФС',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-7-7-0',
                label: 'Жукова Наталья Петровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-1',
                label: 'Ефимова Марина Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-2',
                label: 'Аносова Е.Ф.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-3',
                label: 'Кудина Татьяна Евгеньевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-4',
                label: 'Посошкова С.Е.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-5',
                label: 'Шукшина Людмила Виниаминовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-6',
                label: 'Мартьянова Светлана Евгеньевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-7',
                label: 'Азарова И.В.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-8',
                label: 'Каверин А.А.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-9',
                label: 'Тарасова Н.А.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-10',
                label: 'Кузнецова Т.В.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-11',
                label: 'Рафикова А.А.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-12',
                label: 'Солдатова Ю.А.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-13',
                label: 'Шишигин М.В.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-14',
                label: 'Редькина Елена Кимовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-15',
                label: 'Никитина Л.Г.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-16',
                label: 'Евдокимов Алексей Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-17',
                label: 'Пользователь ОАФУТС ДАФУ КЦ 1',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-18',
                label: 'УЗ интеграционного сервера',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-19',
                label: 'Тарланова Елена Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-20',
                label: 'Рафикова Аделя Амеровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-21',
                label: 'Мордасова Наталья Германовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-22',
                label: 'Фенина Варвара Васильевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-23',
                label: 'СУРТС АПТВ',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-24',
                label: 'Система',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-25',
                label: 'УЗ интеграционного сервера',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-26',
                label: 'УЗ интеграционного сервера',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-27',
                label: 'Интеграционный сервис ССПОД',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-28',
                label: 'Система',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-29',
                label: 'Белова Наталья Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-30',
                label: 'Михайлина Алла Викторовна ',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-7-31',
                label: 'Вербина Дарья Васильевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-7-8',
            label: 'НФТС Нумерация и ГОЗ',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-7-8-0',
                label: 'Авдонова Ирина Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-8-1',
                label: 'Прохонова И.И.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-8-2',
                label: 'Матушкина Ирина Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-8-3',
                label: 'Ушакова Татьяна Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-8-4',
                label: 'Пользователь ЦУСС (ГОЗ)',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-8-5',
                label: 'Шевцов Сергей Петрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-8-6',
                label: 'Белякова Елена Витальевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-8-7',
                label: 'Вершинин Вячеслав Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-8-8',
                label: 'Слюсаренко Елена Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-8-9',
                label: 'Токарева Ольга Евгеньевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-8-10',
                label: 'Зайцева Татьяна Ивановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-8-11',
                label: 'Кудрявцев Максим Игоревич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-8-12',
                label: 'Пьянкова Лариса Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-8-13',
                label: 'Агапов Владимир Геннадьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-8-14',
                label: 'Смирнов Константин Леонидович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-8-15',
                label: 'Алексеенко Артур Дмитриевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-8-16',
                label: 'Смирнов Дмитрий Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-8-17',
                label: 'Кожаев Антон Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-8-18',
                label: 'Дергунов Никита Андреевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-8-19',
                label: 'Микенин Алексей Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-8-20',
                label: 'Худобин Максим Михайлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-7-9',
            label: 'НФСК ОКС7',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-7-9-0',
                label: 'Козлова Галина Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-9-1',
                label: 'Пользователь ОКС-7',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-9-2',
                label: 'Шаврина Мария Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-9-3',
                label: 'Карпинская Наталья Борисовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-9-4',
                label: 'Воронцова Ирина Васильевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-7-10',
            label: 'НПСиТС ТЛГ',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-7-10-0',
                label: 'Власова Юлия Петровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-10-1',
                label: 'Калачева Ольга Борисовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-10-2',
                label: 'Павлова Людмила Борисовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-7-11',
            label: 'НПСиТС ПС',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-7-11-0',
                label: 'Лисицына Ольга Борисовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-11-1',
                label: 'Пользователь ОФПС ГЦУМС',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-11-2',
                label: 'Крюкова Елена Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-11-3',
                label: 'Дестова Наталья Ивановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-11-4',
                label: 'Пряхина Наталья Алексеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-11-5',
                label: 'Дубинина Ольга Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-7-12',
            label: 'НМТС Запад СГМД Смена',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-7-12-0',
                label: 'Смена ЦУСС-СГМД',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-7-13',
            label: 'НМТС Запад СГМД',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-7-13-0',
                label: 'Солодовникова Татьяна Болеславовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-13-1',
                label: 'Шумилов Эдуард Юрьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-13-2',
                label: 'Бринько Марина Петровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-13-3',
                label: 'Моисеева Лариса Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-13-4',
                label: 'Диомидов Антон Борисович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-13-5',
                label: 'Оводков Андрей Игоревич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-7-14',
            label: 'НМТС Запад',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-7-14-0',
                label: 'Горбунова Анастасия Олеговна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-1',
                label: 'Лагутина Марина Юрьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-2',
                label: 'Горбов Владимир Васильевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-3',
                label: 'Евтухов Станислав Олегович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-4',
                label: 'Горбунов Максим Евгеньевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-5',
                label: 'Кваша Екатерина Игоревна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-6',
                label: 'Евтухова Ольга Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-7',
                label: 'Горбунов Сергей Вадимович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-8',
                label: 'Голумбиевская Татьяна Дмитриевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-9',
                label: 'Глинько Сергей Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-10',
                label: 'Величко Иван Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-11',
                label: 'Водолазов Александр Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-12',
                label: 'Носков Андрей Михайлович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-13',
                label: 'Федорова Вера Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-14',
                label: 'Мяконьких Сергей Игоревич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-15',
                label: 'Козельский Сергей Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-16',
                label: 'Москаленко Александр Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-17',
                label: 'Омельяненко Александр Олегович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-18',
                label: 'Тапилин Вадим Игоревич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-19',
                label: 'Макаров Вадим Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-20',
                label: 'Кучерявенко Наталья Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-21',
                label: 'Земляной Евгений Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-22',
                label: 'Молчанов Роман Владимирович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-23',
                label: 'Сазонов Богдан Константинович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-24',
                label: 'Хилько Егор Алексеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-25',
                label: 'Ключникова Елена Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-26',
                label: 'Игушкина Анастасия Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-27',
                label: 'НМТС Запад (рассылка)',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-28',
                label: 'Краснивский Антон Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-29',
                label: 'Сидоренко Андрей Игоревич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-30',
                label: 'Мизяк Леонид Алексеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-31',
                label: 'Плотко Вера Игоревна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-14-32',
                label: 'Стародубцева Анастасия Валерьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-7-15',
            label: 'НМТС Восток',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-7-15-0',
                label: 'Меркулов Владимир Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-15-1',
                label: 'Цик Сергей Андреевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-15-2',
                label: 'Гончарова Елена Семеновна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-15-3',
                label: 'Харлов Дмитрий Геннадьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-15-4',
                label: 'Быкова Ирина Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-15-5',
                label: 'Кошелева Елена Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-15-6',
                label: 'Чемулов Алексей Александрович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-15-7',
                label: 'Ожулас Ольга Валерьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-15-8',
                label: 'Воложанин Павел Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-15-9',
                label: 'Остапенко Денис Валерьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-15-10',
                label: 'Кондратьева Наталья Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-15-11',
                label: 'Паршина Анастасия Юрьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-15-12',
                label: 'Цуканов Максим Олегович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-15-13',
                label: 'Месилова Екатерина Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-15-14',
                label: 'Сафронова Евгения Олеговна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-15-15',
                label: 'Петрашов Александр Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-15-16',
                label: 'Уненов Владимир Игоревич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-15-17',
                label: 'Ликин Филипп Сергеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-15-18',
                label: 'Заводчук Софья Евгеньевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-15-19',
                label: 'Кузнецова Арина Павловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-15-20',
                label: 'Мифтахутдинов Дмитрий Рафаэльевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-15-21',
                label: 'НМТС Восток (рассылка)',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-15-22',
                label: 'Журавлева Александра Вячеславовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-7-16',
            label: 'ДУВС',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-7-16-0',
                label: 'Зоологина Наталья Николаевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-16-1',
                label: 'Белякович Олег Андреевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-16-2',
                label: 'Клименко Ольга Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-16-3',
                label: 'Жуков Дмитрий Анатольевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-16-4',
                label: 'Еремин Дмитрий Васильевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-7-17',
            label: 'ДРС',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-7-17-0',
                label: 'Пользователь ДРС',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-17-1',
                label: 'Гуськова Назия Габдулловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-17-2',
                label: 'Прокопьева Светлана Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-17-3',
                label: 'Репетий Ольга Игоревна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-17-4',
                label: 'Бархота Валерий Алексеевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-17-5',
                label: 'Чекурина Елена Юрьевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-17-6',
                label: 'Старцев Антон Юрьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-17-7',
                label: 'Денисов Михаил Юрьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-7-18',
            label: 'ДРОС',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-7-18-0',
                label: 'Клецова Оксана Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-18-1',
                label: 'Зотова Марина Викторовна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-18-2',
                label: 'Чупина Е.И.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-18-3',
                label: 'Быкова Д.В.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-18-4',
                label: 'Зорина Т.В.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-18-5',
                label: 'Карпова Е.В.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-18-6',
                label: 'Богомолова С. В.',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-18-7',
                label: 'Горбунова Мария Ивановна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-18-8',
                label: 'Бляблина Елена Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-18-9',
                label: 'Пользователь ОПТС ДПС КЦ',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-18-10',
                label: 'Темченко Мария Владимировна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-18-11',
                label: 'Система',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-18-12',
                label: 'Мартемьянова Наталья Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-18-13',
                label: 'Степанов Виталий Игоревич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-18-14',
                label: 'Артемьева Елена Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-18-15',
                label: 'Баранова Анастасия Михайловна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-18-16',
                label: 'Зиявиддинов Тимур Дильшодович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-18-17',
                label: 'Тихомиров Никита Григорьевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-18-18',
                label: 'Сидорович Андрей Георгиевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-7-19',
            label: 'Блок МВ',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-7-19-0',
                label: 'Шустова Мария Алексеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          },
          {
            key: '0-7-20',
            label: ' ДИИГС',
            icon: 'pi pi-fw pi-file',
            children: [
              {
                key: '0-7-20-0',
                label: 'Тюрина Анна Алексеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-20-1',
                label: 'Дрюпина Ирина Анатольевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-20-2',
                label: 'Служебная почта ОПИГИС (МГ)',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-20-3',
                label: 'Ведерникова Марина Валериевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-20-4',
                label: 'Костиков Виталий Николаевич',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-20-5',
                label: 'Ионова Марина Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-20-6',
                label: 'Климова Елена Александровна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-20-7',
                label: 'Митюгин Игорь Викторович',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              },
              {
                key: '0-7-20-8',
                label: 'Богданова Анна Сергеевна',
                icon: 'pi pi-fw pi-file',
                children: [],
                data: 'Сотрудник'
              }
            ],
            data: 'Участок'
          }
        ],
        data: 'Подразделение'
      }
    ],
    data: 'Родитель 1'
  }
];
